export const ONLINE_BOOKING_URL_QUERY_KEY = 'onlineBookingURL'
